import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/timeout';
import { environment } from '../../environments/environment';
import { AuthAccessProvider } from '../core/core.auth';
import { BaseComponent, BaseResponse } from '../core/core.component';
import { AuthenticationService } from '../service/authentication.service';
import { BusyProvider } from '../service/busy.service';
import { MessageProvider } from '../service/message.service';

/**
 * Cambio password su LDAP.
 * Usato dal login per la password scaduta (expiredUsername valorizzato, utente non autenticato)
 * e come pagina per l'utente autenticato.
 */
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent extends BaseComponent {

  // utente con password scaduta: valorizzato solo quando il componente è usato dal login
  @Input() expiredUsername: string = null;
  @Input() oldPassword: string = "";
  // emette la nuova password a cambio avvenuto
  @Output() passwordChanged = new EventEmitter<string>();
  @Output() cancelled = new EventEmitter<void>();

  newPassword: string = "";
  confirmPassword: string = "";

  constructor(protected authAccess: AuthAccessProvider,
              protected router: Router,
              protected messageProvider: MessageProvider,
              private authService: AuthenticationService,
              private busyProvider: BusyProvider)
  {
      super(authAccess, router, messageProvider);
  }

  get expiredMode(): boolean {
      return this.expiredUsername != null;
  }

  get passwordsMismatch(): boolean {
      return this.confirmPassword != null && this.confirmPassword.length > 0 && this.newPassword !== this.confirmPassword;
  }

  changePassword()
  {
      if (this.newPassword !== this.confirmPassword) {
          this.messageProvider.clearAll();
          this.messageProvider.notifyError("La conferma non corrisponde alla nuova password");
          return;
      }
      let newPassword = this.newPassword;
      let request = this.expiredMode
          ? this.authService.changeExpiredPassword(this.expiredUsername, this.oldPassword, newPassword)
          : this.authService.changePassword(this.authAccess.getUserContext().srmToken, this.oldPassword, newPassword);

      this.busyProvider.showBusyIndicator();
      request.timeout(environment.SERVICE_TIMEOUT).subscribe(
          (response: BaseResponse) => {
              this.busyProvider.hideBusyIndicator();
              this.oldPassword = "";
              this.newPassword = "";
              this.confirmPassword = "";
              this.messageProvider.clearAll();
              this.messageProvider.notifyMessage(response.message);
              this.passwordChanged.emit(newPassword);
          },
          error => {
              this.busyProvider.hideBusyIndicator();
              this.handleError(error);
          }
      );
  }

  cancel()
  {
      this.oldPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.messageProvider.clearAll();
      if (this.expiredMode) {
          this.cancelled.emit();
      } else {
          this.router.navigate(['/']);
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/change-password/change-password.component.ts